// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.web.v1.rewards.GetRewardsUpsellWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { GetRewardsUpsellWebApiResponseDto } from '../..';

export const GetRewardsUpsellWebApiHandler_getRewardsUpsell_Path = '/api/web/v1/rewards/getRewardsUpsell';

/**
 * get rewards upsell card display
 */
export const GetRewardsUpsellWebApiHandler_getRewardsUpsell = (client = getClient()) => {
  return httpFrontEndRequest<never, never, GetRewardsUpsellWebApiResponseDto>(
    {
      endpoint: GetRewardsUpsellWebApiHandler_getRewardsUpsell_Path,
      method: 'GET',
      contextPath: '/rent-payment',
    },
    client,
  );
};
